var $e32534e3083f4a62$exports = {};
$e32534e3083f4a62$exports = {
    "rangeOverflow": (args)=>`O valor deve ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data inicial deve ser anterior \xe0 data final.`,
    "rangeUnderflow": (args)=>`O valor deve ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


export {$e32534e3083f4a62$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
